import { render, staticRenderFns } from "./kyc-notification.vue?vue&type=template&id=1a0a998c"
import script from "./kyc-notification.vue?vue&type=script&lang=js"
export * from "./kyc-notification.vue?vue&type=script&lang=js"
import style0 from "./kyc-notification.vue?vue&type=style&index=0&id=1a0a998c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports